import script from "./AiAssistantPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AiAssistantPanel.vue?vue&type=script&setup=true&lang=js"

import "./AiAssistantPanel.vue?vue&type=style&index=0&id=4d5f9b43&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d5f9b43"]])

export default __exports__